$(document).ready(function(){
	$productList = localStorage.getItem('products');
	if($productList != null) {
		if($productList.indexOf(',') != -1) {
			$productList = $productList.split(',');
			var $i = 0;
			$.each($productList, function(){
				if($i < 8) {
					$handle = $productList[$i];
					$.getJSON('/products/' + $productList[$i], function(data) {
						$html = '<div class="product-card-custom recent-viewed-item"><div class="grid-view-item  product-card"><a class="grid-view-item__link grid-view-item__image-container full-width-link" href="/products/' + data.product.handle + '"> <span class="visually-hidden">' + data.product.title + '</span> </a><div class="custom-image-wrapper boost-pfs-action-overlay"><img id="ProductCardImage-6539099668657" class="pp grid-view-item__image ls-is-cached lazyloaded" src="' + data.product.images[1].src + '" alt="diamond wire band ring in 18k gold 23"></div><p class="product-type">' + data.product.product_type + '</p><div class="h4 grid-view-item__title product-card__title">' + data.product.title + '</div> <span cass="price-item"><dl class="price" data-price=""><div class="price__regular"><dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt><dd><span class="price-item price-item--regular" data-regular-price=""><span class="money">' + data.product.variants[0].price + '</span></span></dd></div><div class="price__sale"><dt><span class="visually-hidden visually-hidden--inline"></span></dt><dd><span class="price-item price-item--sale" data-sale-price=""><span class="money">' +data.product.variants[0].price + '</span></span> <span class="price-item__label" aria-hidden="true"></span></dd></div></dl></span></div></div>';
						$('.recently-viewed-container:not(.other-prod-container) .recently-viewed-items').append($html);
					} );
					$i++;
				}
			});
			setTimeout(function(){
				$(".recently-viewed-container:not(.other-prod-container) .recently-viewed-items").mCustomScrollbar({
					axis:'x',
					scrollButtons: {
						enable:true,
						scrollAmount:445,
						scrollType:'stepped'
					},
					theme:'dark'
				});
			}, 1000);
		}
	}
});